import type {
	StripeSchoolSeatsResponse,
	StripeSchoolTeachersResponse,
} from '@kimuno/api-sdk/lib/types/responses/Teacher';

import type { AsyncAction } from './common.actionTypes';

// SUB-95 Phase 1: the Stripe-billed school-admin panel. Kept deliberately
// separate from the legacy `GET_SCHOOL_TEACHERS` / `GET_SCHOOL_SEATS` action
// types so the two panels never share state.

export enum GET_STRIPE_SCHOOL_TEACHERS {
	START = 'GET_STRIPE_SCHOOL_TEACHERS_START',
	SUCCESS = 'GET_STRIPE_SCHOOL_TEACHERS_SUCCESS',
	ERROR = 'GET_STRIPE_SCHOOL_TEACHERS_ERROR',
}

export type GetStripeSchoolTeachersAction = AsyncAction<
	typeof GET_STRIPE_SCHOOL_TEACHERS.START,
	typeof GET_STRIPE_SCHOOL_TEACHERS.SUCCESS,
	typeof GET_STRIPE_SCHOOL_TEACHERS.ERROR,
	StripeSchoolTeachersResponse
>;

export enum GET_STRIPE_SCHOOL_SEATS {
	START = 'GET_STRIPE_SCHOOL_SEATS_START',
	SUCCESS = 'GET_STRIPE_SCHOOL_SEATS_SUCCESS',
	ERROR = 'GET_STRIPE_SCHOOL_SEATS_ERROR',
}

export type GetStripeSchoolSeatsAction = AsyncAction<
	typeof GET_STRIPE_SCHOOL_SEATS.START,
	typeof GET_STRIPE_SCHOOL_SEATS.SUCCESS,
	typeof GET_STRIPE_SCHOOL_SEATS.ERROR,
	StripeSchoolSeatsResponse
>;

export type StripeSchoolTeachersActionTypes =
	| GetStripeSchoolTeachersAction
	| GetStripeSchoolSeatsAction;
